module.exports = __webpack_public_path__ + "static/media/jqrIcon.a0709036.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jqrIcon.png
// module id = 83
// module chunks = 0 1